import { Component } from '@angular/core';

@Component({
  selector: 'rpe-nst2t1',
  standalone: true,
  
  templateUrl: './rpe-nst2t1.component.html',
  styleUrl: './rpe-nst2t1.component.scss'
})
export class RpeNst2t1Component {

}
